import React from "react";
import {Grid, IconButton, Tooltip} from "@material-ui/core";
import {AddButton} from "../AddButton/AddButton";
import { DeleteButton } from "../DeleteButton/DeleteButton";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

const sortBySequenceNumber = (a, b) => a.sequenceNumber - b.sequenceNumber

const changePositionFieldTemplate = (arr, targetFieldId, currentSequenceNumber, newSequenceNumber) => {
    return arr.map(field => {
        if (field.id === targetFieldId) {
            return {...field, sequenceNumber: Number(newSequenceNumber)}
        }
        if (field.sequenceNumber >= newSequenceNumber && field.sequenceNumber < currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber < 0) {
            return {...field, sequenceNumber: field.sequenceNumber + 1}
        }
        if (field.sequenceNumber <= newSequenceNumber && field.sequenceNumber > currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber > 0
        ) {
            return {...field, sequenceNumber: field.sequenceNumber - 1}
        }
        if (field.sequenceNumber === newSequenceNumber && field.sequenceNumber > currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber > 0
        ) {
            return {...field, sequenceNumber: field.sequenceNumber + 1}
        }
        return field
    }).sort(sortBySequenceNumber)
}

const fieldTemplatesSort = (newSequenceNumber, currentSequenceNumber, targetFieldId, arr) => {
    if (newSequenceNumber === currentSequenceNumber || !newSequenceNumber) return arr
    if (Number(newSequenceNumber) >= arr.length) {
        return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, arr.length)
    }
    if (Number(newSequenceNumber) < 1) {
        return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, 1)
    }
    return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, newSequenceNumber)
}

export const FakeAddCheckListField = ({
                                  fakeFields,
                                  handleAddButtonClick,
                                  handleDeleteLast,
                                  handleSequenceNumberChange,
                                  handleFieldTemplateDelete,
                                  handleFieldTemplateClick
                              }) => {
    const handleSequenceNumberChangeWrap = (currentSequenceNumber, targetFieldId) => (event) => {
        const newSequenceNumber = event.target.value
        event.target.select()
        handleSequenceNumberChange(fieldTemplatesSort(newSequenceNumber, currentSequenceNumber, targetFieldId, fakeFields))
    }

    const handleFieldTemplateDeleteWrap = (index, fieldProps) => () => {
        handleFieldTemplateDelete(fieldProps, fakeFields.filter((_, i) => i !== index)
            .map((el, i) => ({...el, sequenceNumber: i + 1})))
    }

    const handleFieldTemplateClickWrap = index => () => {
        handleFieldTemplateClick(index)
    }

    return <Grid container item>
        <Grid item container alignItems={"center"}>
            <Grid item>
                <Tooltip
                    title="Добавить столбец"
                >   
                    <IconButton
                        onClick={handleAddButtonClick}
                    >
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip
                    title="Удалить последний"
                >   
                    <IconButton
                        onClick={handleDeleteLast}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    </Grid>
}